import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoEmailData = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 301,
	height: 138,
	viewBox: "0 0 301 138",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M69.9345 30.9704V112.669C69.9345 113.484 69.774 114.29 69.4621 115.042C69.1503 115.794 68.6934 116.476 68.1177 117.05C67.5419 117.624 66.8587 118.078 66.1075 118.385C65.3563 118.693 64.5518 118.848 63.7406 118.842H53.1241C55.1922 118.842 57.1757 118.017 58.6382 116.549C60.1006 115.082 60.9221 113.09 60.9221 111.015C60.9221 108.938 60.1006 106.947 58.6382 105.479C57.1757 104.011 55.1922 103.187 53.1241 103.187H16.9523C14.8842 103.187 12.9007 102.362 11.4383 100.894C9.97587 99.426 9.1543 97.435 9.1543 95.3591C9.1543 93.2829 9.97587 91.292 11.4383 89.824C12.9007 88.3559 14.8842 87.5312 16.9523 87.5312H36.7147C38.783 87.5312 40.7665 86.7066 42.2288 85.2386C43.6912 83.7705 44.5129 81.7796 44.5129 79.7036C44.5129 77.6275 43.6912 75.6365 42.2288 74.1685C40.7665 72.7005 38.783 71.8758 36.7147 71.8758H16.9523C14.8842 71.8758 12.9007 71.0511 11.4383 69.5831C9.97587 68.1151 9.1543 66.1242 9.1543 64.048C9.1543 61.972 9.97587 59.9811 11.4383 58.5131C12.9007 57.045 14.8842 56.2204 16.9523 56.2204H42.4073C44.4756 56.2204 46.4591 55.3957 47.9214 53.9277C49.3838 52.4596 50.2055 50.4687 50.2055 48.3926C50.2055 46.3166 49.3838 44.3256 47.9214 42.8576C46.4591 41.3896 44.4756 40.5649 42.4073 40.5649H27.6803C25.612 40.5649 23.6286 39.7402 22.1662 38.2722C20.7037 36.8042 19.8822 34.8133 19.8822 32.7371C19.8822 30.6611 20.7037 28.6702 22.1662 27.2022C23.6286 25.7341 25.612 24.9095 27.6803 24.9095H63.7406C65.3602 24.8974 66.9189 25.5271 68.0787 26.662C69.2383 27.7967 69.9053 29.3449 69.9345 30.9704Z",
			fill: "url(#paint0_linear_31300_1030)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M227.963 34.1504V114.522C227.963 115.32 228.12 116.11 228.426 116.847C228.731 117.584 229.179 118.254 229.744 118.818C230.307 119.381 230.977 119.828 231.715 120.133C232.452 120.437 233.243 120.593 234.039 120.592H244.546C242.505 120.592 240.549 119.781 239.106 118.337C237.663 116.894 236.854 114.936 236.854 112.894C236.854 110.853 237.663 108.895 239.106 107.451C240.549 106.008 242.505 105.197 244.546 105.197H280.198C282.239 105.197 284.195 104.386 285.638 102.942C287.081 101.499 287.89 99.541 287.89 97.4996C287.89 95.4581 287.081 93.5003 285.638 92.0567C284.195 90.6131 282.239 89.8022 280.198 89.8022H260.735C258.694 89.8022 256.738 88.9913 255.295 87.5477C253.852 86.1041 253.042 84.1463 253.042 82.1049C253.042 80.0634 253.852 78.1056 255.295 76.662C256.738 75.2184 258.694 74.4075 260.735 74.4075H280.198C282.239 74.4075 284.195 73.5966 285.638 72.153C287.081 70.7094 287.89 68.7516 287.89 66.7102C287.89 64.6687 287.081 62.7109 285.638 61.2673C284.195 59.8237 282.239 59.0128 280.198 59.0128H255.108C253.067 59.0128 251.111 58.2019 249.668 56.7583C248.225 55.3147 247.416 53.3569 247.416 51.3154C247.416 49.274 248.225 47.3162 249.668 45.8726C251.111 44.429 253.067 43.6181 255.108 43.6181H269.647C271.689 43.6181 273.645 42.8072 275.088 41.3636C276.53 39.92 277.34 37.9623 277.34 35.9207C277.34 33.8793 276.53 31.9214 275.088 30.4779C273.645 29.0344 271.689 28.2234 269.647 28.2234H234.039C232.453 28.2201 230.929 28.8387 229.792 29.9466C228.658 31.0544 228 32.5635 227.963 34.1504Z",
			fill: "url(#paint1_linear_31300_1030)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M218.535 130.19H92.3027V127.438H218.535C218.9 127.438 219.25 127.583 219.508 127.841C219.766 128.099 219.911 128.449 219.911 128.814C219.911 129.179 219.766 129.529 219.508 129.787C219.25 130.045 218.9 130.19 218.535 130.19Z",
			fill: "#4A6470"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86.6559 130.19H78.938C78.5732 130.19 78.2234 130.045 77.9654 129.787C77.7075 129.529 77.5625 129.179 77.5625 128.814C77.5625 128.449 77.7075 128.099 77.9654 127.841C78.2234 127.583 78.5732 127.438 78.938 127.438H86.6559C87.0207 127.438 87.3705 127.583 87.6285 127.841C87.8865 128.099 88.0314 128.449 88.0314 128.814C88.0314 129.179 87.8865 129.529 87.6285 129.787C87.3705 130.045 87.0207 130.19 86.6559 130.19Z",
			fill: "#4A6470"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M73.9303 130.19H71.4712C71.1064 130.19 70.7566 130.045 70.4986 129.787C70.2407 129.529 70.0957 129.179 70.0957 128.814C70.0957 128.449 70.2407 128.099 70.4986 127.841C70.7566 127.583 71.1064 127.438 71.4712 127.438H73.9303C74.2951 127.438 74.6449 127.583 74.9029 127.841C75.1609 128.099 75.3058 128.449 75.3058 128.814C75.3058 129.179 75.1609 129.529 74.9029 129.787C74.6449 130.045 74.2951 130.19 73.9303 130.19Z",
			fill: "#4A6470"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M262.799 130.19H224V127.438H262.799C263.163 127.438 263.514 127.583 263.772 127.841C264.031 128.099 264.175 128.449 264.175 128.814C264.175 129.179 264.031 129.529 263.772 129.787C263.514 130.045 263.163 130.19 262.799 130.19Z",
			fill: "#C3C3C3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M64.4376 130.19H25.6367V127.438H64.4376C64.8024 127.438 65.1522 127.583 65.4102 127.841C65.6682 128.099 65.8131 128.449 65.8131 128.814C65.8131 129.179 65.6682 129.529 65.4102 129.787C65.1522 130.045 64.8024 130.19 64.4376 130.19Z",
			fill: "#C3C3C3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M76.7317 22.8191H218.057C220.608 22.8191 223.523 23.3822 225.327 25.1855C227.131 26.9889 227.676 29.8843 227.677 32.4352V123.911H67.1113V32.4352C67.1124 29.8843 67.5788 26.7117 69.3829 24.9083C71.187 23.105 74.181 22.8191 76.7317 22.8191Z",
			fill: "#C3C3C3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M220.22 29.7632H73.2422V114.855H220.22V29.7632Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M228.949 125.181H65.8438V28.334C65.8461 26.5352 66.5616 24.811 67.8334 23.5389C69.1053 22.267 70.8298 21.5516 72.6283 21.5494H222.165C223.963 21.5516 225.688 22.267 226.96 23.5389C228.231 24.811 228.947 26.5352 228.949 28.334V125.181ZM68.3832 122.641H226.41V28.334C226.409 27.2084 225.961 26.1294 225.165 25.3334C224.369 24.5375 223.29 24.09 222.165 24.0889H72.6283C71.5029 24.09 70.4237 24.5375 69.6278 25.3334C68.8321 26.1294 68.3843 27.2084 68.3832 28.334V122.641Z",
			fill: "#35363A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.8613 120.882H252.234V121.557C252.234 123.746 251.364 125.845 249.817 127.393C248.268 128.94 246.169 129.81 243.981 129.81H55.1146C52.9258 129.81 50.8265 128.94 49.2787 127.393C47.7309 125.845 46.8613 123.746 46.8613 121.557V120.882Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M251.182 125.188C250.731 126.362 249.933 127.371 248.897 128.083C247.86 128.795 246.63 129.175 245.373 129.174H52.4416C51.1846 129.174 49.957 128.793 48.9207 128.082C47.8844 127.37 47.0882 126.361 46.6368 125.188H251.182Z",
			fill: "#E2DFE8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M243.02 130.76H54.1558C51.6309 130.757 49.2104 129.753 47.4252 127.968C45.6397 126.182 44.6356 123.762 44.6328 121.237V119.292H252.545V121.237C252.543 123.762 251.538 126.183 249.751 127.969C247.965 129.754 245.544 130.758 243.02 130.76ZM47.1956 121.832C47.3445 123.575 48.1421 125.198 49.4305 126.381C50.7191 127.564 52.4044 128.221 54.1537 128.221H243.02C244.77 128.221 246.454 127.564 247.743 126.381C249.032 125.198 249.83 123.575 249.978 121.832H47.1956Z",
			fill: "#35363A"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 73.5488,
			y: 30,
			width: 146,
			height: 13,
			fill: "#DDE9EC",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 116.549,
			y: 54,
			width: 95,
			height: 9,
			rx: 1.70298,
			fill: "#DDE9EC",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 116.549,
			y: 67,
			width: 28,
			height: 6,
			rx: 1.11978,
			fill: "#DBD7E3"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 116.549,
			y: 82,
			width: 95,
			height: 9,
			rx: 1.70298,
			fill: "#DDE9EC",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 83.5488,
			y: 103,
			width: 22,
			height: 4,
			rx: 1.70298,
			fill: "#DDE9EC",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 74.5488,
			y: 84,
			width: 6,
			height: 4,
			rx: 1.70298,
			fill: "#DDE9EC",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 74.5488,
			y: 68,
			width: 6,
			height: 4,
			rx: 1.70298,
			fill: "#DDE9EC",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 74.5488,
			y: 53,
			width: 6,
			height: 4,
			rx: 1.70298,
			fill: "#DDE9EC",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 116.549,
			y: 95,
			width: 28,
			height: 6,
			rx: 1.11978,
			fill: "#DBD7E3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M84.5488 57L84.5488 97C84.5488 98.6569 85.892 100 87.5488 100C89.2057 100 90.5488 98.6569 90.5488 97L90.5488 57C90.5488 55.3431 89.2057 54 87.5488 54C85.892 54 84.5488 55.3431 84.5488 57Z",
			fill: "#EEECF2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.5488 74L96.5488 97C96.5488 98.6569 97.892 100 99.5488 100C101.206 100 102.549 98.6569 102.549 97L102.549 74C102.549 72.3431 101.206 71 99.5488 71C97.892 71 96.5488 72.3431 96.5488 74Z",
			fill: "#EEECF2"
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [/* @__PURE__ */ _jsx("path", {
				opacity: .5,
				d: "M139.632 30.2661L116.029 119.136H104.143L127.746 30.2661H139.632Z",
				fill: "#F1EFF4"
			}), /* @__PURE__ */ _jsx("path", {
				opacity: .5,
				d: "M169.928 30.2661L146.327 119.136H121.4L145.004 30.2661H169.928Z",
				fill: "#F1EFF4"
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.011 38.263C88.6098 38.5314 88.1375 38.6746 87.6548 38.6746C87.3341 38.6746 87.017 38.6116 86.7206 38.4887C86.4247 38.3659 86.155 38.1861 85.9285 37.9595C85.7019 37.733 85.522 37.4638 85.3991 37.1675C85.2763 36.8712 85.2133 36.5537 85.2133 36.2331C85.2133 35.7501 85.3565 35.2783 85.6249 34.8767C85.8934 34.4751 86.2743 34.162 86.7206 33.9774C87.1666 33.7923 87.6576 33.7445 88.1311 33.8386C88.6046 33.9327 89.0398 34.1652 89.3812 34.5066C89.7226 34.848 89.9552 35.2835 90.0493 35.7569C90.1435 36.2307 90.0952 36.7208 89.9105 37.1671C89.7258 37.6134 89.4127 37.9946 89.011 38.263Z",
			fill: "#F5C04F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.8945 38.263C95.4932 38.5314 95.0213 38.6746 94.5383 38.6746C94.2176 38.6746 93.9001 38.6116 93.6037 38.4887C93.3073 38.3659 93.0381 38.186 92.8115 37.9595C92.5849 37.733 92.4051 37.4638 92.2822 37.1675C92.1593 36.8711 92.0963 36.5537 92.0963 36.233C92.0963 35.7501 92.2395 35.2782 92.508 34.8766C92.7764 34.475 93.1577 34.162 93.6037 33.9773C94.0497 33.7926 94.5407 33.7444 95.0142 33.8385C95.4876 33.9326 95.9228 34.1651 96.2643 34.5065C96.6057 34.8479 96.8383 35.283 96.9324 35.7564C97.0265 36.2302 96.9783 36.7208 96.7936 37.1671C96.6089 37.6133 96.2962 37.9946 95.8945 38.263Z",
			fill: "#61C654"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M82.1281 38.263C81.7264 38.5314 81.2549 38.6746 80.7719 38.6746C80.1245 38.6746 79.5034 38.4174 79.0455 37.9595C78.5876 37.5017 78.3303 36.8807 78.3303 36.233C78.3303 35.7501 78.4735 35.2782 78.742 34.8766C79.0104 34.475 79.3918 34.1624 79.8377 33.9773C80.2837 33.7926 80.7747 33.7444 81.2482 33.8385C81.7216 33.9326 82.1568 34.1651 82.4983 34.5065C82.8397 34.8479 83.0723 35.283 83.1664 35.7568C83.2605 36.2306 83.2123 36.7212 83.0276 37.1675C82.8429 37.6137 82.5298 37.9946 82.1281 38.263Z",
			fill: "#ED6B5F"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_31300_1030",
			x1: 68.8294,
			y1: 72.4284,
			x2: -10.1849,
			y2: 72.4284,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CDF5EE" }), /* @__PURE__ */ _jsx("stop", {
				offset: .38,
				stopColor: "#CDEAFB"
			})]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_31300_1030",
			x1: 230.978,
			y1: 71.5429,
			x2: 294.521,
			y2: 70.4378,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CDF5EE" }), /* @__PURE__ */ _jsx("stop", {
				offset: .38,
				stopColor: "#CDEAFB"
			})]
		})] })
	]
});
export default SvgNoEmailData;
